

/**
 * StatusIndicator Component - Reusable status dot with text
 * 
 * @param {Object} props
 * @param {string} props.status - Status level: 'success', 'warning', 'error', 'loading', 'info'
 * @param {string} props.text - Status text to display
 * @param {string} props.animation - Animation type: 'pulse', 'glow', 'none'
 * @param {string} props.size - Size: 'sm', 'md', 'lg'
 * @param {Object} props.customColor - Custom color override
 */
function StatusIndicator({ 
  status = 'info', 
  text, 
  animation = 'none',
  size = 'md',
  customColor, 
}) {
  // Status color mapping
  const statusColors = {
    success: '#28a745',
    warning: '#ffc107', 
    error: '#dc3545',
    loading: '#6c757d',
    info: '#17a2b8',
  }

  // Size mapping
  const sizes = {
    sm: '1rem',
    md: '1.2rem',
    lg: '1.4rem',
  }

  // Animation mapping
  const animations = {
    pulse: 'pulse 2s infinite',
    glow: 'subtleGlow 3s infinite',
    none: 'none',
  }

  const color = customColor || statusColors[status]
  const fontSize = sizes[size]
  const animationStyle = animations[animation]

  return (
    <div className="d-flex align-items-center">
      <span 
        className="me-2"
        style={{ 
          color,
          fontSize,
          animation: animationStyle,
        }}
      >
        ●
      </span>
      <small className="text-muted fw-medium">{text}</small>
    </div>
  )
}

export default StatusIndicator
